var Handlebars = require("../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"navbar-fixed\">\n    <nav>\n        <div class=\"nav-wrapper teal darken-3\">\n            <div class=\"row\">\n                <div class=\"col s12\">\n            <a href=\"/admin\" class=\"brand-logo push-state\">jiji Admin</a>\n            <ul class=\"right hide-on-med-and-down\">\n                <li>\n                    <a href=\"/admin/oauth\" class=\"push-state\">\n                        OAuth Provider\n                    </a>\n                </li>\n            </ul>\n        </div>\n        </div>\n    </div>\n    </nav>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./jiji/ui/template/header/admin/index.hbs
// module id = 49
// module chunks = 0